import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

interface Props {
  title: string;
  children?: React.ReactNode;
}

/**
 * @description Hero component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const Hero = (props: Props): JSX.Element => {
  return (
    <header className="header-2">
      <div
        className="page-header min-vh-60 hero-background-image"
        style={{ backgroundImage: 'url("/assets/img/canadian-apps2.jpg' }}
      >
        <span className="mask bg-primary opacity-92" />
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-white text-center">
              <h1 className="text-white display-2 font-weight-bolder">
                {props.title}
              </h1>
              {props.children ? (
                <p className="lead text-white mt-3 font-weight-normal">
                  {props.children}
                </p>
              ) : null}
            </Col>
          </Row>
        </Container>
      </div>
    </header>
  );
};

export default Hero;
